'use strict';

import Collection from './collection.js';
import Company from 'newModels/company.js';

export default class Companies extends Collection {
    url() {
        if (this.user && this.user.get('role') === 'employer') {
            return this.user.url() + '/companies';
        }

        if (this.user && this.user.get('role') === 'mpp_admin') {
            return this.user.url() + '/mppCompanies';
        }

        if (this.user && this.user.get('role') === 'mpp_manager') {
            return this.user.url() + '/mppManagedCompanies';
        }

        return '/Companies';
    }

    initialize(models, {user = null, mppSearchString = ''}) {
        this.model = Company;
        super.initialize(...arguments);

        this.mppSearchString = mppSearchString;
        this.mppSearchableAttributes = ['username', 'name'];
        this.searchableAttributes = [
            'companyName', 'contactName', 'contactEmail', 'username'
        ];
        this.user = user;

        return this;
    }

    getMppSearchTerm() {
        return this.mppSearchString || '';
    }

    fetch(options = {}) {
        const mppWhere = {or: []};
        if (this.mppSearchString !== '') {
            const escapedString = this.mppSearchString
                .replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
            this.mppSearchableAttributes.forEach(attr => {
                mppWhere.or.push({
                    [attr]: {regexp: `/^.*${escapedString}.*$/i`}
                });
            });
        }

        if (!mppWhere.or.length) {
            return super.fetch(options);
        }

        const filter = Object.assign(options.filter || {}, {mppWhere});
        return super.fetch(Object.assign({}, options, {filter}));
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/companies.js